





import { computed, defineComponent, PropType, ref, watch } from "@vue/composition-api";
import { debounce } from "lodash-es";
import { ContentSet, InputContentSetUpdate } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { $t } from "@/lib/i18nHelpers";
import { FormFields, FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";

export default defineComponent({
  name: "ShootingDetails",
  components: { BaseForm },
  props: {
    postData: { type: Object as PropType<ContentSet>, required: true },
  },
  setup(props, { emit }) {
    const values = ref<FormValues>({
      shootingLocation: props.postData.shootingLocation ?? "",
      shootingDate: props.postData.shootingDate ?? "",
    });

    const fields = computed<FormFields>(() => [
      {
        name: "shootingLocation",
        label: $t("Shooting location"),
      },
      {
        name: "shootingDate",
        label: $t("Shooting date(s)"),
      },
    ]);

    watch(
      values,
      debounce((v: FormValues) => {
        const data: Omit<InputContentSetUpdate, "id"> = {
          shootingLocation: v.shootingLocation,
          shootingDate: v.shootingDate,
        };
        emit("partialUpdate", { data });
      }, 500)
    );

    return { values, fields };
  },
});
